<mat-form-field class="w-100">
	<mat-select
		[required]="required"
		[formControl]="fieldTeam"
		[compareWith]="compareTeam"
		placeholder="Field Team"
	>
		<mat-option>--</mat-option>
		<mat-option *ngFor="let team of fieldTeams$ | async" [value]="team">
			{{ displayFieldTeam(team) }}
		</mat-option>
	</mat-select>
	<mat-error *ngIf="required">Required</mat-error>
</mat-form-field>
